export default "__VITE_ASSET__DgdEjFuU__"